import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import deviceSelect from '@blade/common/components/device-group-cascader-select/index.vue';
import langMsg from '@blade-sxp/search-center/lang/index';
import UploadModal from '@blade/common/components/img-checker/index.vue';
import ImgRetrieval from '@blade-sxp/search-center/pages/components/globasearch/components/img-retrieval.vue';
import { detectTypes } from '@blade-sxp/search-center/api/index';
import Upload from '@blade-sxp/search-center/pages/components/globasearch/components/upload.vue';
import datePicker from '@blade/common/components/date-time-select/index.vue';
import imgFormat from '@blade/common/components/img-checker/img-format.vue';
import moment from 'moment';
import { fromPage, queryType, routerName } from '@blade-sxp/search-center/interfaces/enum';
import { parameterType } from '@blade-sxp/search-center/utils/index';
let AlarmCenter = class AlarmCenter extends Vue {
    typeList;
    size;
    linkList;
    defaultEvent;
    featureList;
    form = {
        dates: [moment().subtract('days', 1).format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
        eventTypes: this.$props?.defaultEvent,
        inputCard: '',
        inputText: '',
    };
    defaultType = this.$t('picture');
    defaultTime = ['00:00:00', '23:59:59'];
    maxSize = 8000000; // 最大M
    dialogVisible = false; // 特征提取弹框
    base64Image = '';
    loadings = false;
    imgData = null;
    isShow = true;
    imageValid = false;
    loading = false;
    collapseList = [];
    disabled = false;
    type = fromPage.FEATURES_PAGE;
    /**
     * 时间选中变化
     * 值 val
     */
    changeTime(val) {
        console.log(val, '选中时间变化');
    }
    /**
     * 设备选中变化
     * 值 val
     */
    onLabelChange(val) {
        // val.forEach((item: any) => {
        //   console.log(item.label, '选中设备变化');
        // });
    }
    /**
     * 下拉选中变化
     * 值 type
     */
    typeChange(type) {
        this.defaultType = this.$t(type); // 下拉菜单
        this.type = type;
        this.disabled = false;
    }
    retrieval(type, data) {
        // 图搜跳转
        const param = { imageSearchRequest: { featureList: [...data] } };
        this.search(fromPage.FEATURES_PAGE, routerName.SEARCH_PAGE, param);
    }
    onSearch() {
        let defaultType = '';
        let route = '';
        let data = {};
        if (this.type === 'event') {
            defaultType = fromPage.EVENT_PAGE;
            route = routerName.SEARCH_REULIT;
            data = {
                incidentTypeSearchRequest: {
                    incidentTypes: this.form.eventTypes,
                },
            };
        }
        else {
            route = routerName.SEARCH_PAGE;
            let feature = {};
            if (this.type === 'text') {
                defaultType = fromPage.TEXT_PAGE;
                if (!this.form.inputText) {
                    return this.$message.error(this.$t('textInput').toString());
                }
                feature = parameterType(this.featureList, queryType.EVERYTHING, this.form.inputCard);
                data = {
                    textTypeSearchRequest: {
                        ...feature,
                        keyText: this.form.inputText,
                        // featureList: [feature],
                    },
                };
            }
            else {
                defaultType = fromPage.TIME_PAGE;
                if (this.type === 'vehicleNo') {
                    if (!this.form.inputCard) {
                        return this.$message.error(this.$t('pleaseSelectInput').toString());
                    }
                    feature = parameterType(this.featureList, queryType.AUTOMOBILE, this.form.inputCard);
                }
                else {
                    feature = parameterType(this.featureList, this.featureList[0].featureType); // 时空检索 默认查第一个
                }
                data = { attributesSearchRequest: { featureList: [feature] } };
            }
        }
        this.search(defaultType, route, data);
    }
    search(type, route, data) {
        const param = {
            dateEnd: this.form.dates[1],
            dateStart: this.form.dates[0],
            deviceIdList: this.form.device ?? [],
            ...data,
        };
        this.$router.push({ name: route, params: { type: type, param: JSON.stringify(param) } });
    }
    reset() {
        this.form = {
            dates: [moment().subtract('days', 1).format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
            eventTypes: this.defaultEvent,
            inputCard: '',
            inputText: '',
        };
    }
    base64Img(base64Img, index, list) {
        const targetImgObj = list[index];
        this.$set(targetImgObj, 'imageUrl', base64Img);
    }
    checkIndex(indexs, targetCol) {
        const colData = targetCol;
        const oldCheckIndex = colData?.checkIndex ?? '';
        const targetIndex = oldCheckIndex !== indexs ? indexs : '';
        this.$set(colData, 'checkIndex', targetIndex);
    }
    /**
     * 上传图片
     */
    onUpload(base64Image) {
        this.disabled = true;
        const param = {
            base64Image: base64Image,
        };
        return detectTypes(param)
            .then((res) => {
            res.forEach((item, index) => {
                !item.featureList && (item.featureList = []);
                if (item.featureList.length > 0) {
                    item.checkIndex = 0;
                }
                if (item.featureType === 'OBJECT_ALGO') {
                    item.maxLength = 10;
                    item.checkIndex = 0;
                }
            });
            this.collapseList = res.reverse();
            this.dialogVisible = true;
            this.base64Image = base64Image;
        })
            .finally(() => {
            this.disabled = false;
        });
    }
    /**
     * 关闭特征提取
     */
    closeImg() {
        this.dialogVisible = false;
        this.base64Image = null;
        this.$refs.upload.base64Image = null; // 关闭清空上传数据
    }
    /**
     * 选择事件
     */
    changeTypes(val) {
        // console.log(this.form.eventTypes, val, 'this.linkList');
    }
    // 不区分大小写搜索
    dataFilter(node, val) {
        if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
            return true;
        }
    }
};
__decorate([
    Prop()
], AlarmCenter.prototype, "typeList", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "size", void 0);
__decorate([
    Prop({ default: [] })
], AlarmCenter.prototype, "linkList", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "defaultEvent", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "featureList", void 0);
AlarmCenter = __decorate([
    Component({
        name: 'SearchFrom',
        components: { Upload, deviceSelect, UploadModal, ImgRetrieval, datePicker, imgFormat },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], AlarmCenter);
export default AlarmCenter;
